'use strict'

var appComponents = angular.module("app.components", []);

appComponents.component('changeRequestSubmitted', new Patersons.ChangeRequestSubmittedComponent());
appComponents.component('phoneNotRegistered', new Patersons.PhoneNotRegisteredComponent());
appComponents.component('changePhone', new Patersons.ChangePhoneComponent());
appComponents.component('approversNotRegistered', new Patersons.ApproversNotRegisteredComponent());
appComponents.component('sectionHeader', new Patersons.SectionHeaderComponent());
appComponents.component('spinner', new Patersons.SpinnerComponent());
appComponents.component('accountSelect', new Patersons.AccountSelectComponent());
appComponents.component('actionButton', new Patersons.ActionButtonComponent());
appComponents.component('passwordValidation', new Patersons.PasswordValidationComponent());
appComponents.component('dateSelect', new Patersons.DateSelectComponent());
appComponents.component('morningstarError', new Patersons.MorningstarErrorComponent());
appComponents.component('featuredItem', new Patersons.FeaturedItemComponent());
appComponents.component('feedList', new Patersons.feedListComponent());